import React from 'react';
import Select from './Select';

const MultiSelect = (props) => <Select {...props} multi />;

export default MultiSelect;
